module.exports = __webpack_public_path__ + "img/sumita.88dc5416.jpg";